// The help centre lives on its own site (help.mintlink.in, the MINTLINK-HELP
// repo). Every link into it from the app goes through this map, so when an
// article moves there is one place to fix — and a key that isn't here fails
// loudly in dev instead of shipping a link to a 404.
//
// Paths are the article's URL on the help site: src/content/docs/<section>/<slug>.md
// in MINTLINK-HELP is served at /<section>/<slug>.

export const HELP_URL = 'https://help.mintlink.in';

export const HELP_TOPICS = {
  home: { path: '/', label: 'Help Centre' },

  // Getting started
  firstSteps: { path: '/getting-started/first-steps', label: 'Your first 10 minutes' },
  tour: { path: '/getting-started/find-your-way-around', label: 'Find your way around' },
  bank: { path: '/getting-started/add-bank-details', label: 'Adding bank or UPI details' },

  // What you can sell
  digital: { path: '/selling/digital-products', label: 'How digital products work' },
  events: { path: '/selling/tickets-and-events', label: 'How tickets & events work' },
  checkIn: { path: '/selling/check-in-attendees', label: 'How check-in works' },
  memberships: { path: '/selling/memberships', label: 'How memberships work' },
  membershipCheckIn: { path: '/selling/memberships#checking-members-in', label: 'Checking members in' },
  membershipRetention: { path: '/selling/memberships#keeping-members', label: 'Keeping members' },
  quizzes: { path: '/selling/quizzes', label: 'How quizzes work' },
  forms: { path: '/selling/mintlink-forms', label: 'How MintLink Forms work' },
  reviewMyWork: { path: '/selling/review-my-work', label: 'How Review My Work works' },
  services: { path: '/selling/freelance-services', label: 'How services work' },
  supporters: { path: '/selling/supporters', label: 'How supporters work' },

  // Website & growth
  website: { path: '/website-and-growth/your-website', label: 'How your website works' },
  domain: { path: '/website-and-growth/custom-domain', label: 'Connecting your domain' },
  discounts: { path: '/website-and-growth/discount-codes', label: 'How discount codes work' },
  autodm: { path: '/website-and-growth/instagram-auto-dm', label: 'How Auto DM works' },
  plus: { path: '/website-and-growth/mintlink-plus', label: 'What Plus includes' },
  referrals: { path: '/website-and-growth/referrals', label: 'How referrals work' },

  // Fees & payouts
  payouts: { path: '/money/payouts', label: 'How payouts work' },
  fees: { path: '/money/fees', label: 'Fees explained' },
  gst: { path: '/money/gst-invoices', label: 'GST invoices' },
  refunds: { path: '/money/refunds', label: 'Refunds' },

  // Buyers
  buyerDownload: { path: '/buyers/download-your-purchase', label: 'Trouble downloading?' },
  buyerTicket: { path: '/buyers/your-event-ticket', label: 'Help with your ticket' },
  buyerOrder: { path: '/buyers/get-help-with-an-order', label: 'Help with an order' },
};

export function helpUrl(topic = 'home') {
  const entry = HELP_TOPICS[topic];
  if (!entry) {
    if (process.env.NODE_ENV !== 'production') console.warn(`[help] unknown help topic "${topic}"`);
    return HELP_URL;
  }
  return entry.path === '/' ? `${HELP_URL}/` : HELP_URL + entry.path;
}
